export const STOREFRONT_API_ACCESS_TOKEN_DEV = '25973894cefd939fb6311f6a893af23d'
export const STOREFRONT_API_ACCESS_TOKEN_PROD = '59a148c0ca1697095ee44c51858b3ea1'
export const STOREFRONT_URL = `https://${window.Shopify.shop}/api/2024-01/`
